import {
  INIT,
  SET_PAYLOAD,
  SET_RESPONSE,
  FETCHING,
  FETCHING_SUCCESS,
  FETCHING_FAIL,
  ABORT_FETCHING,
} from './types';

export const createInit = type => () => ({
  type: `${type}${INIT}`,
});

export const createSetPayload = type => payload => ({
  type: `${type}${SET_PAYLOAD}`,
  payload,
});

export const createSetResponse = type => response => ({
  type: `${type}${SET_RESPONSE}`,
  response,
});

export const createFetching = type => () => ({
  type: `${type}${FETCHING}`,
});

export const createFetchingSuccess = type => response => ({
  type: `${type}${FETCHING_SUCCESS}`,
  response,
});

export const createFetchingFail = type => (errorCode, errorMsg) => ({
  type: `${type}${FETCHING_FAIL}`,
  errorCode,
  errorMsg,
});

export const createAbortFetching = type => () => ({
  type: `${type}${ABORT_FETCHING}`,
});

const createAllActions = type => ({
  init: createInit(type),
  setPayload: createSetPayload(type),
  setResponse: createSetResponse(type),
  fetching: createFetching(type),
  fetchingSuccess: createFetchingSuccess(type),
  fetchingFail: createFetchingFail(type),
  abortFetching: createAbortFetching(type),
});

export default createAllActions;
